import { useEffect } from 'react';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? window.location.origin
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001');

const useVisitTracker = (pageName) => {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await fetch(`${API_BASE_URL}/api/stats/visits`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page_visited: pageName
          })
        });
      } catch (error) {
        console.error('Erreur lors du suivi de la visite:', error);
      }
    };

    trackVisit();
  }, [pageName]);
};

export default useVisitTracker; 